"use client";
import React from "react";
import Tag from "../Tag/Tag";
import CustomNavLink from "../CustomLink/CustomNavLink";
import { useDictionary } from "../DictProvider/DictProvider";
import Product from "../Product/Product";

interface FeatureProductProps {
  tag: string;
  product: any;
  url: string; // Replace YourProductType with the actual type of your product data
}

const FeatureProduct: React.FC<FeatureProductProps> = ({
  url,
  tag,
  product,
}) => {
  const translate = useDictionary();
  return (
    <>
      <Tag name={tag} />

      <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 overflow-hidden no-scrollbar mx-4 p-2">
        <Product product={product?.slice(0, 4)} />
      </div>

      {product?.length > 4 && (
        <div className="flex justify-center">
          <CustomNavLink href={`trends?type=${url?.toLowerCase()}`}>
            <button className="mt-12 rounded-lg px-3 py-1.5 border border-primary text-primary font-base font-semibold">
              {translate?.Home?.viewmore}
            </button>
          </CustomNavLink>
        </div>
      )}
    </>
  );
};

export default FeatureProduct;
